import Lockr from 'lockr'
// this file just serves to set options for Lockr
Lockr.prefix = 'yOS_'

export default Lockr